module.exports = __webpack_public_path__ + "img/sld_scb_6_green.a4224dfa.svg";